import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'autodistrict-cookie-consent';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const choice = localStorage.getItem(STORAGE_KEY);
      if (!choice) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* ignore */ }
    if (value === 'rejected' && typeof window !== 'undefined' && window.posthog) {
      try { window.posthog.opt_out_capturing?.(); } catch (e) { /* ignore */ }
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6 pointer-events-none"
      data-testid="cookie-consent"
    >
      <div className="pointer-events-auto max-w-5xl mx-auto bg-white border border-slate-200 rounded-2xl shadow-2xl">
        <div className="grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-5 items-center p-5 md:p-6">
          <div className="hidden md:flex w-12 h-12 rounded-full border border-emerald-200 bg-emerald-50 items-center justify-center text-emerald-600">
            <Cookie size={22} strokeWidth={1.8} />
          </div>
          <div className="text-slate-600 text-sm leading-relaxed">
            <p className="text-slate-900 font-semibold mb-1 text-[15px]">
              {t('cookies.title', 'Votre confidentialité')}
            </p>
            <p className="text-slate-500 text-[13px]">
              {t(
                'cookies.body',
                "Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic et personnaliser le contenu. Vous pouvez accepter ou refuser. Vos préférences seront mémorisées.",
              )}{' '}
              <Link
                to="/politique-confidentialite"
                onClick={() => setVisible(false)}
                className="text-blue-900 hover:text-blue-700 underline underline-offset-2 font-medium transition-colors"
                data-testid="cookie-learn-more"
              >
                {t('cookies.learnMore', 'En savoir plus')}
              </Link>
            </p>
          </div>
          <div className="flex flex-wrap gap-2 md:flex-nowrap items-center">
            <button
              type="button"
              onClick={() => persist('rejected')}
              className="text-slate-700 hover:text-slate-900 text-xs font-semibold px-4 py-3 border border-slate-200 hover:border-slate-300 rounded-full transition-colors"
              data-testid="cookie-reject"
            >
              {t('cookies.reject', 'Refuser')}
            </button>
            <button
              type="button"
              onClick={() => persist('accepted')}
              className="text-white bg-blue-900 hover:bg-blue-800 text-xs font-bold px-5 py-3 rounded-full transition-colors"
              data-testid="cookie-accept"
            >
              {t('cookies.accept', 'Accepter')}
            </button>
            <button
              type="button"
              onClick={() => persist('rejected')}
              className="text-slate-400 hover:text-slate-700 p-2 transition-colors md:hidden"
              aria-label="Close"
              data-testid="cookie-close"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
